import { Switch } from "@productlane/ui"
import { mutators } from "@productlane/zero/mutators"

import { analytics } from "@/lib/analytics"
import { mutateOk, useZero } from "@/lib/zero"
import { SettingItem } from "../settings-switches/setting-item"
import { SettingsContainer } from "../settings-switches/settings-container"

export function WeeklyRoadmapEmailSetting({
	workspaceId,
	weeklyRoadmapEmailEnabled,
}: {
	workspaceId: string
	weeklyRoadmapEmailEnabled: boolean
}) {
	const zero = useZero()

	const handleToggle = async (value: boolean) => {
		await mutateOk(
			zero.mutate(
				mutators.workspaces.update({
					id: workspaceId,
					weeklyRoadmapEmailEnabled: value,
				}),
			),
		)
		analytics.track("toggle-weekly-roadmap-email", { value })
	}

	return (
		<SettingsContainer className="mt-4">
			<SettingItem
				title="Weekly roadmap email"
				description="Survey active customers when new items are published (weekly)."
				action={
					<Switch
						name="weeklyRoadmapEmailEnabled"
						label={null}
						checked={weeklyRoadmapEmailEnabled}
						onCheckedChange={handleToggle}
					/>
				}
			/>
		</SettingsContainer>
	)
}
